/* eslint-disable react-hooks/exhaustive-deps */
import {useCallback, useMemo} from 'react'

import {DEFAULT_EMPTY_SELECTIONS} from '../../config.js'

const useAllSelectionsField = ({allSelectionsId, allSelectionsLabel, onChange, value}) => {
  const currentDefaultSelections = allSelectionsLabel ? [allSelectionsId] : DEFAULT_EMPTY_SELECTIONS

  const hasAllOptionsChecked = useMemo(() => {
    const [firstValue] = value
    return firstValue === allSelectionsId
  }, [allSelectionsId, value])

  const handleSelectAll = useCallback(
    () => !hasAllOptionsChecked && onChange([allSelectionsId]),
    [allSelectionsId, hasAllOptionsChecked, onChange]
  )

  return {hasAllOptionsChecked, defaultSelections: currentDefaultSelections, onSelectAll: handleSelectAll}
}

export default useAllSelectionsField
